export default "__VITE_ASSET__DbA$QERK__"